import { render } from "./SaleOrderDetailsView.vue?vue&type=template&id=b3e32940&scoped=true&ts=true"
import script from "./SaleOrderDetailsView.vue?vue&type=script&lang=ts"
export * from "./SaleOrderDetailsView.vue?vue&type=script&lang=ts"

import "./SaleOrderDetailsView.vue?vue&type=style&index=0&id=b3e32940&scoped=true&lang=css"
import "./SaleOrderDetailsView.vue?vue&type=style&index=1&id=b3e32940&lang=scss"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e32940"]])

export default __exports__